<template>
  <div>
    <div class="w-[824] mx-[auto] pb-[60]">
      <div class="flex-center px-[30] h-[134] bg-[#E5EDFF] cursor-pointer rounded-[6]" @click="push({ path: '/sign/selectSign', query: { signFileType: signFileType, ...$route.query } })">
        <div class="flex items-center">
          <div>
            <img src="../assets/img/loan/img3.png" class="w-[62]" alt="" />
          </div>
          <div class="pl-[17]">
            <p class="t-[theme] t-[20] pb-[10]">线上签章</p>
            <p class="t-[#777]">均适合使用线上签章的个人及企业场景</p>
          </div>
        </div>
        <div class="w-[46] text-center leading-[46] rounded-[100%] bg-[#fff] shadow1">
          <i class="icon t-[theme] cursor-pointer t-[16]">&#xe646;</i>
        </div>
      </div>
      <div class="text-right pt-[20]" v-if="offlineSeal">
        <span class="t-[#606266]">无法进行线上签章？</span>
        <span class="t-[theme] cursor-pointer t-[16]" @click="push({ path: '/sign/offlineSeal', query: { ...$route.query } })">线下签章</span>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
  mixins: [mixin],
  name: "dg-sign-entry",
  props: {
    signFileType: {
      type: String,
      default: "",
    },
    offlineSeal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>
<style scoped></style>
 <style>.w-\[824\] {
    width: 824px
}
.mx-\[auto\] {
    margin-left: auto;
    margin-right: auto
}
.pb-\[60\] {
    padding-bottom: 60px
}
.px-\[30\] {
    padding-left: 30px;
    padding-right: 30px
}
.h-\[134\] {
    height: 134px
}
.bg-\[\#E5EDFF\] {
    background-color: #E5EDFF
}
.rounded-\[6\] {
    border-radius: 6px
}
.w-\[62\] {
    width: 62px
}
.pl-\[17\] {
    padding-left: 17px
}
.t-\[theme\] {
    color: #008AA6
}
.t-\[20\] {
    font-size: 20px
}
.pb-\[10\] {
    padding-bottom: 10px
}
.t-\[\#777\] {
    color: #777
}
.w-\[46\] {
    width: 46px
}
.leading-\[46\] {
    line-height: 46px
}
.rounded-\[100\%\] {
    border-radius: 100%
}
.bg-\[\#fff\] {
    background-color: #fff
}
.t-\[16\] {
    font-size: 16px
}
.pt-\[20\] {
    padding-top: 20px
}
.t-\[\#606266\] {
    color: #606266
}
.flex-center {
    display: flex;
    justify-content: space-between;
    align-items: center
}
.cursor-pointer {
    cursor: pointer
}
.flex {
    display: flex
}
.items-center {
    align-items: center
}
.text-center {
    text-align: center
}
.text-right {
    text-align: right
}</style>